import React from 'react';

export default function PaymentReceiptRecovery({ receipt, onVerified }) {
    if (!receipt.pending && !receipt.error) return null;
    return <div style={{ marginTop: 8 }}>
        {receipt.pending && <>
            <p role="status">A payment was submitted. Verify it before sending another payment.</p>
            <button className="muulti-button" type="button" disabled={receipt.verifying}
                onClick={async () => {
                    try { const result = await receipt.verify(); onVerified?.(result); }
                    catch { /* The receipt hook displays the verification error. */ }
                }}>
                {receipt.verifying ? 'Verifying payment...' : 'Verify submitted payment'}
            </button>
        </>}
        {receipt.error && <p role="alert">{receipt.error}</p>}
    </div>;
}
